import cn from 'classnames'
import { memo, type ReactElement } from 'react'
import { PRETTY_TRANSACTION_STATUS, GlobalTransactionStatus } from '../../types/GlobalTransactionStatus'

interface StatusLabelProps {
  status: GlobalTransactionStatus | undefined | null
}

const STATUS_TEXT_COLORS = {
  [GlobalTransactionStatus.Return]: '#7f95a0',
  [GlobalTransactionStatus.Cancelled]: 'red',
  [GlobalTransactionStatus.Error]: 'red',
  [GlobalTransactionStatus.Complete]: '#29975B',
  [GlobalTransactionStatus.Paid]: '#112837',
  [GlobalTransactionStatus.Pending]: '#EF7F2E'

}

const STATUS_BG_COLORS = {
  [GlobalTransactionStatus.Return]: '#FFFFFF00',
  [GlobalTransactionStatus.Cancelled]: '#FACCD3',
  [GlobalTransactionStatus.Error]: '#FACCD3',
  [GlobalTransactionStatus.Complete]: '#E1F4EC',
  [GlobalTransactionStatus.Paid]: '#E0E5E8',
  [GlobalTransactionStatus.Pending]: '#F5EADD'

}

function TransactionStatusLabel ({ status }: StatusLabelProps): ReactElement {
  if (!status) { return <div /> }
  return (
    <div
      className={
        cn(
          'px-3 py-1 rounded-full font-semibold text-center',
          status === GlobalTransactionStatus.Return && 'italic'
        )
      }
      style={{
        backgroundColor: STATUS_BG_COLORS[status],
        border: `1px solid ${STATUS_TEXT_COLORS[status]}`,
        color: STATUS_TEXT_COLORS[status]
      }}
    >
      {PRETTY_TRANSACTION_STATUS[status]}
    </div>
  )
}

export default memo(TransactionStatusLabel)
